import { useFormik } from 'formik';
import { useEffect } from 'react';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';
import { IParams } from '../../../../../../shared/types/redirectParams';

export const useFinalCausalityData = (finalCausality?: IParams) => {
    const formik = useFormik({
        initialValues: {
            finalCausality: '',
            causeNumber: '',
            realCause: '',
            meaning: '',
            description: '',
            active: false,
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const causalityName = finalCausality?.name || '';
        const [causeNumber, ...realCause] = causalityName.split(' - ');
        formik.setValues({
            finalCausality: useGetNameOrValue(finalCausality?.parent || ''),
            causeNumber: causeNumber || '',
            realCause: realCause.join(' - ') || '',
            meaning: finalCausality?.extra || '',
            description: finalCausality?.extra2 || '',
            active: finalCausality?.active || false,
        });
    }, [finalCausality]);

    return {
        formik,
    };
};
